document.body.addEventListener('builtBcSfFilter', function(event){

  // product Object
  var product = event.detail.product;
  // Recupero i metafields per fare il replace delle sezioni
  jQuery.get('/products/'+product.handle+'?view=metafields')
    // Se tutto ok, faccio il replace dei metafield
    .done(function(data){
      try{
        var metafields = JSON.parse(data);
        var productItemContainer = jQuery('#product-'+product.id+'-grid-item');
        if (productItemContainer.length > 0){
          // Itero sui metafields ottenuti dal prodotto
          var numeroCapsule = '10';
          for(key in metafields){
            if (key == "numero_capsule") {
              numeroCapsule = metafields[key];
            } else {
              regExpHtmlReplace(productItemContainer, '{{item_'+key+'}}', metafields[key]);
              productItemContainer.find('[data-infoname="' + key + '"]').show();
            }
          }

          // il field 'numero_capsule' non è definito su tutte le capsule, se non c'è inseriamo 10 come quantità di default
          var key = 'listing_numero_capsule';
          regExpHtmlReplace(productItemContainer, '{{item_'+key+'}}', numeroCapsule);
          productItemContainer.find('[data-infoname="' + key + '"]').show();
        }
      }
      catch(e){
        console.log(e);
      }
    })
    // faccio il replace di tutti gli altri placeholder
    .then(function(){
      var productItemContainer = jQuery('#product-'+product.id+'-grid-item');
      if(productItemContainer.length > 0){  // Se presente il prodotto

        // replace dei placeholders per i tag filtro
        product.tags.forEach(tag => {
          var tokens = tag.split('-');
          if(tokens.length > 1){
            var tagCategory = tokens.shift();
            var tagValue = tokens.join('-');
            var regex = '{{item_'+tagCategory+'}}';
            regExpHtmlReplace(productItemContainer, regex, tagValue);
            productItemContainer.find('[data-infoname="' + tagCategory + '"]').show();
          }
        });

        // Recupero dell'id di variante
        regExpHtmlReplace(productItemContainer, '{{item_variant_id}}', product.variants[0].id);
        // Recupero le varianti disponibili
        var colorsHtml = "";
        product.variants.forEach(variant => {
          var color = variant.option_colore;
          colorsHtml += "<em class=\"color-option tooltip-wrapper\" for=\"" + color + "\"><span class=\"custom-tooltip\">" + color + "</span></em>";
        });
        regExpHtmlReplace(productItemContainer, '{{item_variant_colors}}', colorsHtml);
        // Recupero della quantit&agrave; di variante disponibile
        regExpHtmlReplace(productItemContainer, '{{max_quantity}}', product.variants[0].inventory_quantity);
        // Disattiviamo i controlli se il prodotto è esaurito
        let disabled = product.variants[0].inventory_quantity == 0 ? "disabled" : "";
        regExpHtmlReplace(productItemContainer, '{{out_of_stock_disabled}}', disabled);

        // I prodotti vendibili solo in bundle non si aggiungono al carrello ne' ai preferiti
        if(product.tags && product.tags.indexOf('non-vendibile-singolarmente') !== -1){
          var addButton = productItemContainer.find('.add-cart-btn[data-product-id]');
          var addContainer = addButton.closest('.add-cart-container');
          (addContainer.length ? addContainer : addButton).remove();
          productItemContainer.find('.smartwishlist').remove();
        }
      }

      // Faccio refresh della lista di prodotti in sessione
      // Trovare modo di farlo una volta sola
      sessionStoreProducts();
  });
});

  function regExpHtmlReplace(domObject, regex, value){
    var html = domObject.html();
    domObject.html(html.replace(new RegExp(regex, 'g'), value));
  }

  function addToCart(addButton, needsReload){

    var qty = parseInt(addButton.data('quantity'));
    if(qty===0){
      return;
    }
    sessionStoreMinicartImages(addButton.data('product-handle'), addButton.data('minicart-img'));


    var params = {
      url: '/cart/add.js',
      data: {
        id: parseInt(addButton.data('product-id')),
        quantity: qty
      },
      dataType: 'json'
    };

    $.post(params)
      .done(function(item){
        jQuery('.minicart').trigger('updateMiniCart');
        updateItemQuantity(addButton, 1);
      	showCartPopup(addButton, item, qty);
        if (needsReload != undefined && needsReload == true) {
          window.location.reload();
        }
      })
      .fail(function(err){
        console.log(err);
      	var errorMessage = err.responseJSON ? err.responseJSON.description : theme.strings.cartError;
        showCartErrorMessage(errorMessage);
      });
  }

  function changeSubscriptionType(checkbox) {
    var addButton = checkbox.closest(".add-cart-group").find('.add-cart-btn');

    // leggiamo il valore attuale e invertiamolo
    var current = addButton.data('subscription-type');
    var updated = current == "onetime" ? "recurring" : "onetime";
    addButton.data('subscription-type', updated);

    // visualizziamo il prezzo appropriato in base alla ricorrenza selezionata
    if (updated == "onetime") {
      checkbox.closest('.product-card').find('.price-recurring').hide();
      checkbox.closest('.product-card').find('.price-onetime').show();
    } else {
      checkbox.closest('.product-card').find('.price-onetime').hide();
      checkbox.closest('.product-card').find('.price-recurring').show();  
    }
  }

  // funzione usata nel flusso degli abbonamenti per controllare il numero di confezioni
  function addToCartSubs(addButton){
    var quantity = parseInt(addButton.data('quantity'));
    if (quantity === 0) {
      return;
    }

    var properties = {};
    var isOneTime = addButton.data('subscription-type') == 'onetime';
    if (isOneTime) {
      properties = {
        'onetime': true,
        'subscription_one_time': true
      };
    }

    sessionStoreMinicartImages(addButton.data('product-handle'), addButton.data('minicart-img'));
    
    var productId = addButton.data('product-id');
    var data = {
      id: parseInt(productId),
      quantity: quantity,
      properties: properties
    };

    // Per gestire i prezzi scontati di Recharge, dobbiamo aggiungere i prodotti al carrello
    // già specificando un selling plan.
    if (isOneTime == false) {
      var sellingPlanId = addButton.data('selling-plan-id');
      data['selling_plan'] = sellingPlanId;
    }
    
    var params = {
      url: '/cart/add.js',
      data: data,
      dataType: 'json'
    };

    $.post(params)
      .done(function(item){
        jQuery('.minicart').trigger('updateMiniCart');
        updateItemQuantity(addButton, 1);
        showCartPopup(addButton, item, quantity);
      })
      .fail(function(err){
        var errorMessage = err.responseJSON ? err.responseJSON.description : theme.strings.cartError;
        showCartErrorMessage(errorMessage);
      })
      .success(function(){
        // nope
      })
      .error(function(jqXHR, textStatus, errorThrown) {
        console.log('[ERROR] Unable to update cart');
        console.log(jqXHR);
      });
  }

  function manageQuantity(btn){
      var addCartBtn = btn.closest('.add-cart-container').find('.add-cart-btn');
      var quantity = parseInt(addCartBtn.data('quantity'));
      if (btn.hasClass('add-btn') && quantity < parseInt(addCartBtn.data('max-quantity'))) {
        quantity += 1;
      } else if (btn.hasClass('remove-btn') && quantity > 1) {
        quantity -= 1;
      }

      // remove button is enabled only when quantity is greather than 1
      var removeBtn =  btn.closest('.add-cart-container').find('.remove-btn');
      if (quantity > 1) {
        removeBtn.removeAttr('disabled');
      } else {
        removeBtn.attr('disabled', 'disabled');
      }

      updateItemQuantity(addCartBtn, quantity);
  }

  function updateItemQuantity(addCartBtn, quantity){
    addCartBtn.data('quantity', quantity); // Quantita da inviare a carrello
    addCartBtn.find('.qty-value').text(quantity); //Quantita da mostrare
  }

  // Costruisce lista ordinata di url di prodotti da mettere in sessione
  // per funzioni di next/prev su pagina dettaglio prodotto
  function sessionStoreProducts(){
    // recuperai i prodotti con attributo 'data-handle'
    var products = jQuery('[data-handle]');
    if(products.length > 0){
      var handles = [];
      products.each(function(){
        var product = jQuery(this);
        // per ogni prodotto recupero url da attributo 'href'
        var url = product.find('a.more').first();
        url = url ? url.attr('href') : '';
        // e handle da attributo 'data-handle'
        var handle = jQuery(this).data('handle')
        // Aggiungo l'oggetto alla mappa da mettere in sessione
        handles.push({ handle: handle, url: url });
      });
      sessionStorage.setItem('products', JSON.stringify(handles));
    }
  }

/** CART POPUP **/

function showCartPopup(addCartBtn, item, quantity){

  var cartPopup = jQuery('.cart-popup');

  jQuery('[data-cart-popup-title]').text(item.product_title);
  jQuery('[data-cart-popup-quantity]').text(quantity);
  jQuery('[data-cart-popup-quantity-label]').text(
    theme.strings.quantityLabel.replace('[count]', quantity)
  );

  setupCartPopupImage(
    item.featured_image.url,
    item.featured_image.aspect_ratio,
    item.featured_image.alt
  );

  setupCartPopupProductDetails(
    item.product_has_only_default_variant,
    item.options_with_values,
    item.properties
  );

  setupCartPopupEventListeners();

  var $cartPopupWrapper = jQuery('[data-cart-popup-wrapper]');

  $cartPopupWrapper
    .prepareTransition()
    .removeClass('cart-popup-wrapper--hidden');

  slate.a11y.trapFocus({
    $container: $cartPopupWrapper,
    $elementToFocus: cartPopup,
    namespace: 'cartPopupFocus'
  });

  setTimeout(function() {
    $cartPopupWrapper
      .prepareTransition()
      .addClass('cart-popup-wrapper--hidden');

      slate.a11y.removeTrapFocus({
        $container: $cartPopupWrapper,
        namespace: 'cartPopupFocus'
      });  
  }, 3000);
}

function setupCartPopupImage(imageUrl, imageAspectRatio, imageAlt) {
    var cartPopupImgWrapper = jQuery('[data-cart-popup-image-wrapper]');
    var cartPopupImgPlaceholder = jQuery('[data-cart-popup-image-placeholder]');
    if (imageUrl === null) {
      cartPopupImgWrapper.addClass('hide');
      return;
    }

    var placeholder = jQuery('[data-placeholder-size]');
    var maxWidth = 95 * imageAspectRatio;
    var heightRatio = 100 / imageAspectRatio;

    cartPopupImgPlaceholder.css('max-width', maxWidth);

    placeholder.css('padding-top', heightRatio + '%');

  	cartPopupImgWrapper.removeClass('hide');
    var sizedImageUrl = theme.Images.getSizedImageUrl(imageUrl, '200x');
    var image = document.createElement('img');
    image.src = sizedImageUrl;
    image.alt = imageAlt;
    image.classList.add('cart-popup-item__image');
    image.dataset.cartPopupImage = '';

    image.onload = function() {
      cartPopupImgPlaceholder.addClass('hide');
      cartPopupImgWrapper.append(image);
    }.bind(this);
}

function setupCartPopupProductDetails(product_has_only_default_variant,
      options,
      properties) {

  	var cartPopupProductDetails = jQuery('[data-cart-popup-product-details]');
    var variantPropertiesHTML = '';
    if (!product_has_only_default_variant) {
      variantPropertiesHTML =
        variantPropertiesHTML + getCartPopupVariantOptionList(options);
    }

    if (properties !== null && Object.keys(properties).length !== 0) {
      variantPropertiesHTML =
        variantPropertiesHTML + getCartPopupPropertyList(properties);
    }

    if (variantPropertiesHTML.length === 0) {
      cartPopupProductDetails.html('');
      cartPopupProductDetails.attr('hidden', '');
    } else {
      cartPopupProductDetails.html(variantPropertiesHTML);
      cartPopupProductDetails.removeAttr('hidden');
    }
}

function getCartPopupVariantOptionList(variantOptions) {
  var variantOptionListHTML = '';

  variantOptions.forEach(function(variantOption) {
    variantOptionListHTML =
      variantOptionListHTML +
      '<li class="product-details__item product-details__item--variant-option">' +
      variantOption.name +
      ': ' +
      variantOption.value +
      '</li>';
  });

  return variantOptionListHTML;
}

function getCartPopupPropertyList(properties) {

  var propertyListHTML = '';
  var propertiesArray = Object.entries(properties);

  propertiesArray.forEach(function(property) {
    // Line item properties prefixed with an underscore are not to be displayed
    if (property[0].charAt(0) === '_') return;

    // if the property value has a length of 0 (empty), don't display it
    if (property[1].length === 0) return;

    propertyListHTML =
      propertyListHTML +
      '<li class="product-details__item product-details__item--property">' +
      '<span class="product-details__property-label">' +
      property[0] +
      ': </span>' +
      property[1];
    ': ' + '</li>';
  });

  return propertyListHTML;
}

function setupCartPopupEventListeners() {
  jQuery('[data-cart-popup-wrapper]').on(
         'keyup',
         function(event) {
    if (event.keyCode === slate.utils.keyboardKeys.ESCAPE) {
      this._hideCartPopup(event);
    }
  }.bind(this)
  );

  jQuery('[data-cart-popup-close]').on('click', hideCartPopup);
  jQuery('[data-cart-popup-dismiss]').on('click', hideCartPopup);
  $('body').on('click', function(event) {
      var $target = $(event.target);

      if (
        $target[0] !== jQuery('[data-cart-popup-wrapper]')[0] &&
        !$target.parents('[data-cart-popup]').length
      ) {
        hideCartPopup(event);
      }
    });
}

function hideCartPopup(event) {
  var setFocus = event.detail === 0 ? true : false;
  var cartPopupWrapper = jQuery('[data-cart-popup-wrapper]');
  cartPopupWrapper
  .prepareTransition()
  .addClass('cart-popup-wrapper--hidden');

  $('[data-cart-popup-image]').remove();
  $('[data-cart-popup-image-placeholder]').removeClass('hide');

  slate.a11y.removeTrapFocus({
    $container: cartPopupWrapper,
    namespace: 'cartPopupFocus'
  });

  cartPopupWrapper.off('keyup');
  jQuery('[data-cart-popup-close]').off('click');
  jQuery('[data-cart-popup-dismiss]').off('click');
  $('body').off('click');
}

function showCartErrorMessage(errorMessage) {
  jQuery('#cartErrorMessage').html(errorMessage).modal('show');
}
